import { apiFetch } from "../useApi";

export default async function updateDevicesStatus({ deviceIds, status }) {
  const response = await apiFetch(`/devices/update_status`, {
    method: 'PUT',
    body: JSON.stringify({ deviceIds, status }),
  });
}
